import { useState, useEffect } from 'react';
import Collapsible from 'react-collapsible';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SettingsFieldRow from '@IssueConsoleRepresentationalDisplay/SettingsFieldRow';
import FieldForm from '@CommonForms/FieldForm';
import BoxOptions from '@CommonFunctionalDisplay/BoxOptions';
import FieldPageView from '@CommonViews/FieldPageView';
import { IoChevronForwardOutline as PathArrow } from 'react-icons/io5';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import FieldPageService from '@Helpers/URLHelpers/FieldPageService';
import './SettingsFieldPageRow.scss';

export default function SettingsFieldPageRow(props) {

    const [fieldPageFieldIdList, setFieldPageFieldIdList] = useState([]);
    const [fieldPageTitle, setFieldPageTitle] = useState(null);
    const [, setPageBackground] = useState({});
    const [, setPageHeader] = useState({});
    const [showFieldPageView, setShowFieldPageView] = useState(false);
    const [localFormFieldList, setLocalFormFieldList] = useState(props?.formFieldList ?? []);
    const [, setTheme] = useState({});
    const [showCreateFieldForm, setShowCreateFieldForm] = useState(false);
    const [, setBackgroundStyle] = useState({});
    const [currentUserProjectPermissions, setCurrentUserProjectPermissions] = useState({});
    const { getUserPermissionByProjectId } = useReduxProject();
    const [collapsibleOpen, setCollapsibleOpen] = useState(false);
    const fieldPageService = new FieldPageService();
    const className = 'settingsFieldPageRow';

    useEffect(() => {
        parseData();
    }, [props])

    useEffect(() => {
        setLocalFormFieldList(props?.formFieldList ?? []);
    }, [props?.formFieldList])

    const parseData = () => {
        if(!!props?.fieldPage?.details){
            let detailsObj = JSON.parse(props.fieldPage.details);
            setPageBackground(detailsObj?.pageBackground);
            setPageHeader(detailsObj?.pageHeader);
            setFieldPageTitle(detailsObj?.title ?? null);
            setTheme(detailsObj?.theme);
            setFieldPageFieldIdList(JSON.parse(props.fieldPage?.fields));
            const pageBackgroundObjValue = props?.formDetails?.settings?.pageBackground;
            if(pageBackgroundObjValue) {
                if(pageBackgroundObjValue.type === 'solid') {
                    setBackgroundStyle({
                        background: pageBackgroundObjValue.color
                    });
                } else if(pageBackgroundObjValue.type === 'image') {
                    setBackgroundStyle({
                        backgroundImage: 'url("' + pageBackgroundObjValue.imageURL + '")',
                        backgroundSize: 'cover'
                    });
                }
            }
        }
        let currentUserProjectPermissionsObj = getUserPermissionByProjectId([props.fieldPage?.projectId]);
        setCurrentUserProjectPermissions(currentUserProjectPermissionsObj);
    }

    const toggleShowCreateFieldForm = () => {
        setShowCreateFieldForm(!showCreateFieldForm)
    }

    const toggleCollapsibleOpen = () => {
        if(collapsibleOpen) {
            document.getElementById('arrow__KRFP' + props.index).style.transform = 'rotate(0)'
        } else {
            document.getElementById('arrow__KRFP' + props.index).style.transform = 'rotate(90deg)';
        }
        setCollapsibleOpen(!collapsibleOpen);
    }

    const shiftFieldUp = async(index) => {
        props.setCursor('wait');
        if(index > 0) {
            let fieldPageFieldIdListObj = fieldPageFieldIdList;
            let tempPageId = fieldPageFieldIdListObj[index - 1];
            fieldPageFieldIdListObj[index - 1] = fieldPageFieldIdListObj[index];
            fieldPageFieldIdListObj[index] = tempPageId;
            let fieldPageObj = props?.fieldPage;
            fieldPageObj.fields = JSON.stringify(fieldPageFieldIdListObj);
            await fieldPageService.updateFieldPage(fieldPageObj);
            props.renderData();
        }
        props.setCursor('auto');
    }

    const shiftFieldDown = async(index) => {
        let fieldPageFieldIdListObj = fieldPageFieldIdList;
        if(index < fieldPageFieldIdListObj.length - 1) {
            let tempField = fieldPageFieldIdListObj[index + 1];
            fieldPageFieldIdListObj[index + 1] = fieldPageFieldIdListObj[index];
            fieldPageFieldIdListObj[index] = tempField;
            let fieldPageObj = props?.fieldPage;
            fieldPageObj.fields = JSON.stringify(fieldPageFieldIdListObj);
            await fieldPageService.updateFieldPage(fieldPageObj);
            props.renderData();
        }
    }

    const toggleShowFieldPageView = () => {
        setShowFieldPageView(!showFieldPageView);
    }

    const handleFieldCreated = (createdField) => {
        if (!createdField?.id) {
            return;
        }
        setFieldPageFieldIdList((prev) => {
            const fieldIdList = prev ?? [];
            if (fieldIdList.includes(createdField.id)) {
                return fieldIdList;
            }
            return [...fieldIdList, createdField.id];
        });
        setLocalFormFieldList((prev) => {
            const formFieldList = prev ?? [];
            if (formFieldList.some((field) => field?.id === createdField.id)) {
                return formFieldList;
            }
            return [...formFieldList, createdField];
        });
    }


    return (
        <div className={className + ' border-shadow'}>
            <div className={className + '__inner width-wfa'}>
                <Collapsible
                    trigger={
                        <div className={className + '__inner__trigger flex-row-center-space-between'}>
                            <div className={className + '__inner__trigger__left flex-row-center-1vw-gap semi-bold-text'}>
                                <PathArrow className={className + '__inner__trigger__pathArrow dashboard-icon standard-link'}
                                    id={'arrow__KRFP' + props.index}
                                    onClick={toggleCollapsibleOpen}/>
                                <div className={className + '__inner__trigger__t1'}>
                                    {
                                        fieldPageTitle ?? 'Page ' + (props.index + 1)
                                    }
                                </div>
                                <div className={className + '__inner__trigger__t1'}>
                                    Total Fields: {fieldPageFieldIdList?.length}
                                </div>
                            </div>
                            <div className={className + '__inner__trigger__right flex-row-center-1vw-gap'}>
                                <BoxOptions
                                    hovered
                                    showSettings={!!currentUserProjectPermissions?.allowCreate}
                                    showShiftUp
                                    showShiftDown
                                    showView={false}
                                    shiftUpDisabled={props.index === 0 || props.kaiziqResolveConnection.connectionLive}
                                    settingsDisabled={props.kaiziqResolveConnection.connectionLive}
                                    deleteDisabled={props.kaiziqResolveConnection.connectionLive}
                                    shiftDownDisabled={props.index === (props?.formFieldPageList?.length - 1) || props.kaiziqResolveConnection.connectionLive}
                                    handleShiftUpClickCallback={() => props.shiftFieldPageUp(props.index)}
                                    handleShiftDownClickCallback={() => props.shiftFieldPageDown(props.index)}
                                    handleSettingsClickCallback={toggleShowFieldPageView}
                                    handleDeleteClickCallback={() => props.handleDeleteFieldPageClick(props?.index)}/>
                            </div>
                        </div>
                    }
                    open={collapsibleOpen}
                    transitionTime={200}
                    triggerDisabled={true}
                    classParentString={className + '__inner__trigger__collapsible width-wfa'}>
                    {
                        collapsibleOpen &&
                            <div className={className + '__inner__display'}>
                                <div className={className + '__inner__display__inner flex-column-center-2vh-gap'}>
                                    {
                                        fieldPageFieldIdList?.map((fieldId, index) =>
                                            <SettingsFieldRow
                                                fieldId={fieldId}
                                                fieldPageFieldIdList={fieldPageFieldIdList}
                                                field={localFormFieldList.find((formField) => formField.id === fieldId)}
                                                index={index}
                                                shiftFieldUp={shiftFieldUp}
                                                shiftFieldDown={shiftFieldDown}
                                                fieldPage={props.fieldPage}
                                                kaiziqResolveConnection={props.kaiziqResolveConnection}
                                                formDetails={props.formDetails}
                                                renderData={props.renderData}/>
                                        )
                                    }
                                    {
                                        !props.kaiziqResolveConnection.connectionLive &&
                                        <div className={className + '__inner__display__inner__create flex-row-center-1rem-gap border-shadow click'} onClick={toggleShowCreateFieldForm}>
                                            <AddCircleOutlineIcon/> Create Field
                                        </div>
                                    }
                                </div>
                            </div>
                    }
                </Collapsible>
            </div>
            {
                showCreateFieldForm &&
                    <FieldForm
                        open={showCreateFieldForm}
                        fieldPage={props.fieldPage}
                        fieldPageFieldIdList={fieldPageFieldIdList}
                        kaiziqResolveConnection={props.kaiziqResolveConnection}
                        closePopup={toggleShowCreateFieldForm}
                        onFieldCreated={handleFieldCreated}
                        reloadData={props.renderData}/>
            }
            {
                showFieldPageView &&
                    <FieldPageView
                        open={showFieldPageView}
                        closePopup={toggleShowFieldPageView}
                        fieldPage={props.fieldPage}
                        formFieldPageList={props?.formFieldPageList}
                        formFieldPageIdList={props?.formFieldPageIdList}
                        fieldPageFieldIdList={fieldPageFieldIdList}
                        formFieldList={props?.formFieldList}
                        formDetails={props?.formDetails}
                        reloadFieldPageListData={props?.reloadFieldPageListData}
                        kaiziqResolveConnection={props.kaiziqResolveConnection}
                        index={props.index}/>
            }
        </div>
    )
}
